// Web-only modal pushing users to the Android app. Used to gate features
// that we want to keep app-exclusive (Get Featured, streak, full feed, etc).
// Tapping the Play badge opens an in-app "how to download" walkthrough
// instead of deep-linking to the Play listing — we want users to search the
// app organically to boost Play Store ranking.
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Smartphone } from "lucide-react";
import { HowToDownloadDialog } from "@/components/HowToDownloadDialog";

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title?: string;
  description?: string;
}

export const GetTheAppDialog = ({
  open,
  onOpenChange,
  title = "Get the full experience on the app",
  description = "Download FitAuraAI - Try On Clothes from the Google Play Store to use this feature.",
}: Props) => {
  const [howOpen, setHowOpen] = useState(false);
  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-sm rounded-3xl">
          <DialogHeader className="text-left">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/30 to-accent/20 text-primary ring-1 ring-primary/30">
              <Smartphone className="h-6 w-6" />
            </div>
            <DialogTitle className="text-center">{title}</DialogTitle>
            <DialogDescription className="text-center">
              {description} Search <span className="font-semibold text-foreground">FitAuraAI - Try On Clothes</span> on the Google Play Store.
            </DialogDescription>
          </DialogHeader>

          <button
            type="button"
            onClick={() => setHowOpen(true)}
            className="mx-auto mt-2 block transition-transform active:scale-95"
            aria-label="See how to download FitAuraAI"
          >
            <img src="/google-play-badge.svg" alt="Get it on Google Play" className="h-12 w-auto" />
          </button>

          <Button
            variant="ghost"
            className="mt-2 w-full rounded-full"
            onClick={() => onOpenChange(false)}
          >
            Maybe later
          </Button>
        </DialogContent>
      </Dialog>

      <HowToDownloadDialog open={howOpen} onOpenChange={setHowOpen} />
    </>
  );
};
